import { render, staticRenderFns } from "./OpenDoorDialog.vue?vue&type=template&id=bd0e6060&"
import script from "./OpenDoorDialog.vue?vue&type=script&lang=ts&"
export * from "./OpenDoorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports